<script setup>
const props = defineProps({
  text: {
    type: String,
    default: 'opebo',
  },
});
</script>
<template>
  <span class="text-transparent font-bold bg-clip-text bg-gradient-to-r to-emerald-600 from-sky-400">{{ props.text }}</span>
</template>
